import gql from 'graphql-tag';

import { buildQueryHook } from '../../../utils/buildQueryHook';
import {
  ListWorkOrders,
  ListWorkOrdersVariables,
  ListWorkOrders_homework_listWorkOrders_workOrders as WorkOrders,
} from '../../athena/types/ListWorkOrders';

export const LIST_WORK_ORDERS = gql`
  query ListWorkOrders($ids: [String!]) {
    homework {
      listWorkOrders(input: { ids: $ids }) {
        workOrders {
          id
          lineItems {
            state
          }
        }
      }
    }
  }
`;

export default buildQueryHook<ListWorkOrders, ListWorkOrdersVariables, WorkOrders[] | null>(
  LIST_WORK_ORDERS,
  {
    wrangler: (data) => data?.homework?.listWorkOrders?.workOrders || null,
  },
);
